import React from 'react'
import Createpost from './Createpost'
import CommunityPost from './CommunityPost'
import ProductsliderPost from './ProductsliderPost'
import ServicesPost from './ServicesPost'
import JobsPost from './JobsPost'

function Postmain() {
  return (
    <>
    <Createpost/>
    <CommunityPost/>
    <ProductsliderPost/>
    <ServicesPost/>
    <JobsPost />
    </>
  )
}

export default Postmain
